export const FONT_FAMILY_STACKS = {
  sans: '"Inter","Inter Fallback",Helvetica,Arial,sans-serif',
  serif: 'ui-serif,Georgia,Cambria,"Times New Roman",Times,serif',
  mono: '"GeistMono",ui-monospace,SFMono-Regular,Roboto Mono,Menlo,Monaco,Liberation Mono,DejaVu Sans Mono,Courier New,monospace',
} as const;

export type FontFamilyOptionKey = keyof typeof FONT_FAMILY_STACKS;

export const HIDDEN_FOOTNOTE_VALUE = " ";
export const MAX_FOOTNOTE_LENGTH = 30;

export type FontFamilyOption = {
  value: FontFamilyOptionKey;
  labelId: string;
  defaultMessage: string;
  stack: string;
  displayFont: string;
};

export const FONT_FAMILY_OPTIONS: FontFamilyOption[] = [
  {
    value: "sans",
    labelId: "settings.fontInter",
    defaultMessage: "Arial (Sans Serif)",
    displayFont: "Arial, sans-serif",
    stack: FONT_FAMILY_STACKS.sans,
  },
  {
    value: "serif",
    labelId: "settings.fontTimesNewRoman",
    defaultMessage: "Times New Roman (Serif)",
    displayFont: '"Times New Roman", serif',
    stack: FONT_FAMILY_STACKS.serif,
  },
  {
    value: "mono",
    labelId: "settings.fontMonospace",
    defaultMessage: "Courier (Monospace)",
    displayFont: '"Courier New", Courier, monospace',
    stack: FONT_FAMILY_STACKS.mono,
  },
];

export const isFontFamilyOptionKey = (
  value: string | null | undefined
): value is FontFamilyOptionKey => {
  if (!value) return false;
  return FONT_FAMILY_OPTIONS.some((option) => option.value === value);
};

export const isFootnoteHidden = (
  footnote: string | null | undefined
): boolean => footnote === HIDDEN_FOOTNOTE_VALUE;

export const serializeFootnote = (
  footnote: string,
  hideFootnote: boolean
): string | null => {
  if (hideFootnote) return HIDDEN_FOOTNOTE_VALUE;
  return footnote.trim() || null;
};
